import {
  logout
} from "./chunk-USNUKULP.mjs";

// src/hooks/wbk/auth/logout.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
var useLogout = (props) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      queryClient.setQueryData(["user", props], null);
      queryClient.clear();
    }
  });
};

export {
  useLogout
};
//# sourceMappingURL=chunk-LERXOQNA.mjs.map